import { clientEnv } from "@/clientEnv";
import { isListenLabsUrl } from "@/utils/helpers";
import { postJson } from "@/utils/routeUtils";

export const trackError = async ({
  error,
  componentStack,
  eventId,
  errorPlace,
  context,
}: {
  error: Error;
  componentStack: string | null;
  eventId: string | null;
  errorPlace: string;
  context?: string;
}) => {
  console.log("tracking error:", error);
  let url: string | null = null;
  // want to be extra careful since sometimes window or globalThis is not defined
  try {
    if (typeof window !== "undefined") {
      url = window.location.href;
    }
  } catch (e) {
    console.error("Error getting URL", e);
  }
  if (url && !isListenLabsUrl(url)) {
    return;
  }

  // Unpinned, so the route reads the current build and can tell a stale tab from a fresh one.
  await postJson(
    "/api/track_error",
    {
      error: {
        name: error?.name,
        message: error?.message,
        stack: error?.stack,
      },
      componentStack,
      eventId,
      url,
      errorPlace,
      context,
      clientBuild: clientEnv.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? null,
    },
    { shouldPinDeployment: false }
  );
};
